import { Link } from "react-router-dom";

import Reveal from "./Reveal";
import TypedHeading from "./TypedHeading";
import useAnchorNav from "../../hooks/useAnchorNav";

// Closing call-to-action band with a radial glow. Buttons are { label, kind:
// "anchor" | "route", target } — anchors smooth-scroll (routing to Home first
// if needed), routes use <Link>.
const CtaBanner = ({ title, lede, primary, secondary }) => {
  const navigateToHash = useAnchorNav();

  const renderButton = (btn, className) => {
    if (!btn) {
      return null;
    }
    if (btn.kind === "route") {
      return (
        <Link to={btn.target} className={className}>
          {btn.label}
        </Link>
      );
    }
    return (
      <a
        href={`#${btn.target}`}
        className={className}
        onClick={(event) => {
          event.preventDefault();
          navigateToHash(btn.target);
        }}
      >
        {btn.label}
        {className.includes("primary") && <span className="cta-banner__arrow">←</span>}
      </a>
    );
  };

  return (
    <section className="cta-banner">
      <div className="cta-banner__wash" aria-hidden="true" />
      <div className="cta-banner__inner">
        <TypedHeading text={title} className="cta-banner__title" />
        <Reveal as="p" className="cta-banner__lede">{lede}</Reveal>
        <Reveal className="cta-banner__actions">
          {renderButton(primary, "cta-banner__btn cta-banner__btn--primary")}
          {renderButton(secondary, "cta-banner__btn cta-banner__btn--ghost")}
        </Reveal>
      </div>
    </section>
  );
};

export default CtaBanner;
